import React from 'react';
import { ParticipantViewModel, ParticipantVirtualGraduationViewModel } from 'stageclip-common';

import AppModal from 'components/modal/appModal';
import { makeGuardedModal, GuardedModalContentComponentProps } from 'components/guardedModal/makeGuardedModal';
import { SimpleModalId } from 'constants/modalId';
import styles from 'components/events/participants/reviewModal/ReviewModal.module.scss';

export const PreviewMOModal = ({
  id,
  data: { participant },
}: GuardedModalContentComponentProps<{
  participant: ParticipantViewModel & { virtualGraduation: ParticipantVirtualGraduationViewModel };
}>) => {
  return (
    <AppModal id={id} title="Preview" hideActionButtons hideOpenButton>
      <section className={styles.section}>
        <h3>Slide:</h3>
        <img src={participant.virtualGraduation.slidePath} alt="Slide" />
      </section>
    </AppModal>
  );
};

export const PreviewMOModalContainer = makeGuardedModal(SimpleModalId.PreviewSlide, PreviewMOModal);
